import styled from 'styled-components'
import Colors from '../../theme/colors'
import Fonts from '../../theme/fonts'

export const RadioButtonStyles = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  font-family: ${Fonts.fontFamilies.Inter};
  font-weight: ${Fonts.fontWeights.medium};
  font-style: normal;
  font-size: ${Fonts.fontSizes.p16};
  line-height: 16px;
  letter-spacing: 0.01em;

  label {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    padding: 0 16px;
    white-space: nowrap;

    &.disabled {
      cursor: not-allowed;
      color: ${Colors.Primary.Grey};
    }
  }

  input {
    cursor: pointer;
    position: relative;
    appearance: none;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    background-color: white;
    border: 1px solid ${Colors.Primary.GreyTextLight};
    margin: 0;

    &:checked {
      border: 1px solid ${Colors.Primary.yellow500};

      &:before {
        content: '';
        position: absolute;
        top: 3px;
        left: 3px;
        border-radius: 50%;
        width: 8px;
        height: 8px;
        background-color: ${Colors.Primary.yellow500};
      }
    }

    &:disabled {
      cursor: not-allowed;
      border: 1px solid ${Colors.Primary.Grey};

      &:before {
        background-color: ${Colors.Primary.Grey};
      }
    }

    &:hover:not(:disabled):not(:checked) {
      border: 1px solid ${Colors.Primary.GreyDark};
    }

  }
`

export default RadioButtonStyles
